export default function Footer({ content }) {
    return (
        <footer className="relative border-t border-white/10 py-14 md:py-20">
            <div className="max-w-[1600px] mx-auto px-5 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
                    <div className="md:col-span-6">
                        <div className="font-mono uppercase text-4xl md:text-6xl tracking-tighter leading-none">
                            JAI&apos;REL <span className="text-brand-gold">YOUNG</span>
                        </div>
                        <div className="chapter-num mt-4">
                            Class of {content.athlete.graduationYear} · 132 lb · Wendell NC
                        </div>
                        <p className="editorial text-white/70 text-xl mt-4 max-w-lg">
                            Actively seeking college wrestling opportunities. Coaches — reach out
                            anytime.
                        </p>
                    </div>
                    <div className="md:col-span-3">
                        <div className="chapter-num">Direct</div>
                        <a
                            href={`mailto:${content.recruitingEmail}`}
                            className="font-mono text-sm mt-3 block hover:text-brand-gold break-all"
                        >
                            {content.recruitingEmail}
                        </a>
                    </div>
                    <div className="md:col-span-3">
                        <div className="chapter-num">Site Map</div>
                        <ul className="mt-3 space-y-1 font-mono text-sm text-white/70">
                            <li><a className="hover:text-brand-gold" href="#highlights">Highlights</a></li>
                            <li><a className="hover:text-brand-gold" href="#profile">Wrestling Profile</a></li>
                            <li><a className="hover:text-brand-gold" href="#academics">Academics</a></li>
                            <li><a className="hover:text-brand-gold" href="#contact">Contact</a></li>
                            <li><a className="hover:text-brand-gold" href="/admin">Admin</a></li>
                        </ul>
                    </div>
                </div>
                <div className="mt-14 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-3 font-mono text-[10px] tracking-[0.25em] uppercase text-white/40">
                    <span>© {new Date().getFullYear()} Jai&apos;Rel Young Recruiting</span>
                    <span>Corinth Holders HS · Capital City WC</span>
                    <span>Wendell, North Carolina</span>
                </div>
            </div>
        </footer>
    );
}
